import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ExternalIdentityProvider, ExternalIdentityProviderCreate, ExternalIdentityProviderFilter } from '../data/externalIdentityProvider';

export function createExternalIdentityProviderService(client: AxiosInstance) {
  return createCrudService<ExternalIdentityProvider, ExternalIdentityProviderCreate, ExternalIdentityProviderFilter>(
    client,
    '/identity/ExternalIdentityProvider',
    'id',
  );
}

export type ExternalIdentityProviderService = CrudService<ExternalIdentityProvider, ExternalIdentityProviderCreate, ExternalIdentityProviderFilter>;
